import { createFileRoute } from '@tanstack/react-router'

import { CreateAccountPage } from '@/modules/auth'

export const Route = createFileRoute('/create-account')({
  staticData: { title: 'Create account' },
  component: CreateAccountPage,
})
